import { Box, Logo, Text } from '@tocktix/pantry';
import { Theme, css } from '@emotion/react';

const badge = ({ colors, spacing }: Theme) => css`
  &.gda-badge {
    padding: ${spacing(0.25)}px;
    border-radius: 100%;
    fill: ${colors.bgContrast};
    background-color: ${colors.borderGdaBase};
  }
`;
interface GdaBadgeProps {
  variant?: 'icon' | 'badge' | 'badgeWithLabel';
  iconColor?: 'black' | 'white' | 'brand';
  size?: 'sm' | 'md' | 'lg';
}

const GdaBadge = ({ variant = 'badge', iconColor = 'black', size = 'lg' }: GdaBadgeProps) => {
  let iconHeight;
  switch (size) {
    case 'sm':
      iconHeight = 10;
      break;
    case 'md':
      iconHeight = 12;
      break;
    case 'lg':
      iconHeight = 16;
      break;
  }

  switch (variant) {
    case 'icon':
      return <Logo height={iconHeight} variant="gdaIcon" color={iconColor} className="gda-badge" />;
    case 'badge':
      return <Logo height={iconHeight} variant="gdaIcon" css={badge} className="gda-badge" />;
    case 'badgeWithLabel':
      return (
        <Box display="flex" gap={50} alignItems="center">
          <Logo height={iconHeight} variant="gdaIcon" css={badge} className="gda-badge" />
          <Text variant="captionStrong" color="fgGdaStrong" setLineHeightToSelf>
            Global Dining Access
          </Text>
        </Box>
      );
  }
};

export default GdaBadge;
